const zIndexMap = {
  modal: 50,
  dock: 100,
  settingsButton: 20,
  settingsModal: 120,
  resetModal: 150
}

export default zIndexMap;


// WEBPACK FOOTER //
// ./src/utils/zIndexMap.js